import LoginContainer from "./components/login_main";
import {Route, Routes} from 'react-router-dom';
import NoFoungPage from "./components/noFoungPage";
import CatalogArea from "./components/catalogs/catalogArea";
import CatalogPart from "./components/catalogs/catalogPartida";
import CatalogBuilding from "./components/catalogs/catalogBuilding";
import CatalogProperty from "./components/catalogs/catalogProperty";
import CatalogInventory from "./components/catalogs/catalogInventory";
import ShowInfoInventory from "./components/showInfoInventory";
import CatalogAsignSafe from "./components/catalogs/catalogAsignSafe";
import UnauthorizedPage from "./components/unauthorized";
import Navbar from "./components/navbar";
function App() {
  return (
    <div className="App">
    <Navbar/>
      <Routes>
          <Route path='/' element={<LoginContainer/>}/>
          <Route path='/area' element={<CatalogArea/>}/> 
          <Route path='/part' element={<CatalogPart/>}/>
          <Route path='/building' element={<CatalogBuilding/>}/>
          <Route path='/property' element={<CatalogProperty/>}/>
          <Route path='/inventory' element={<CatalogInventory/>}/>
          <Route path='/asign-safe' element={<CatalogAsignSafe/>}/>
          <Route path='/unauthorized' element={<UnauthorizedPage/>}/>
          <Route path='/info/:uuid' element={<ShowInfoInventory/>}/>
          <Route path='/*' element={<NoFoungPage/>}/>
      </Routes>
    </div>
  );
}
export default App;